import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

export interface IQuestionaireSubmitItem {
    questionId: number;
    comment: string;
    comment_type: number;
    name?: string;
    is_anonymous?: number;
}

export interface IPostData {
    sessionId: number;
    // data: ISubmitItem[];
    data: string;
}

export interface IQuestionaireResponse {
    comment_id: number;
    // points_result:[]
}

export const submitQuestionaire = (data: IPostData): Promise<IQuestionaireResponse> => {
    return fetchData(Api.QUESTIONAIRE_SUBMIT, data).then((res: IResponse<IQuestionaireResponse>) => res.data);
};
